import $ from 'jquery';

$(function () {
    if ($('#our_story_page').length) {    


        $(window).scroll(function () {
            var i = 0;
            for (i = 1; i < 10; i++) {
                var element = "#pt" + i;
                if (isScrolledIntoView(element)) {
                    $(element).css("border", "5px solid #138890")
                }
            }
        });


    }


    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height() - 200;
        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));


    }

   
});